export function useSwiperDirectionObserver(swiper: any) {
    let dirMutationObserver: MutationObserver | null = null

    const setup = () => {
        if (!swiper) return

        dirMutationObserver = new MutationObserver(mutationsList => {
            for (const mutation of mutationsList) {
                if (mutation.attributeName === 'dir') {
                    swiper.changeLanguageDirection(document.documentElement.dir)

                    swiper.slides.forEach((slide: HTMLElement) => {
                        slide.style.marginLeft = ''
                        slide.style.marginRight = ''
                    })

                    requestAnimationFrame(() => swiper.update())
                }
            }
        })

        dirMutationObserver.observe(document.documentElement, {
            attributeFilter: ['dir']
        })
    }

    const cleanup = () => {
        if (dirMutationObserver) {
            dirMutationObserver.disconnect()
            dirMutationObserver = null
        }
    }

    return {
        setup,
        cleanup
    }
}